// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/experiment_results.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { ConcentrationSummaryRecord } from "./concentration_summary_record_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_concentration_summary_record } from "./concentration_summary_record_pb";
import type { CurveFitPlotData } from "./curve_fit_plot_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_curve_fit_plot_data } from "./curve_fit_plot_data_pb";
import type { ReplicateResultRecord } from "./replicate_result_record_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_replicate_result_record } from "./replicate_result_record_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/experiment_results.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_experiment_results: GenFile = /*@__PURE__*/
  fileDesc("CkBxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZXhwZXJpbWVudF9yZXN1bHRzLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEi5AIKEUV4cGVyaW1lbnRSZXN1bHRzEiQKDWV4cGVyaW1lbnRfaWQYASABKAlCCIK1GAQYASABSACIAQESZQoYc3VtbWFyeV9hbmFseXNpc19yZXN1bHRzGAIgAygLMkMucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkNvbmNlbnRyYXRpb25TdW1tYXJ5UmVjb3JkElgKEGFuYWx5c2lzX3Jlc3VsdHMYAyADKAsyPi5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuUmVwbGljYXRlUmVzdWx0UmVjb3JkElYKE2N1cnZlX2ZpdF9wbG90X2RhdGEYBCADKAsyOS5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuQ3VydmVGaXRQbG90RGF0YUIQCg5fZXhwZXJpbWVudF9pZGIGcHJvdG8z", [file_quanterix_common_extensions_v1_field_options, file_quanterix_simoa_one_analysis_app_api_v1_concentration_summary_record, file_quanterix_simoa_one_analysis_app_api_v1_curve_fit_plot_data, file_quanterix_simoa_one_analysis_app_api_v1_replicate_result_record]);

/**
 * Contains Analysis Results for a single experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ExperimentResults
 */
export type ExperimentResults = Message<"quanterix.simoa_one.analysis_app_api.v1.ExperimentResults"> & {
  /**
   * Unique id (UUID) of this experiment
   *
   * @generated from field: optional string experiment_id = 1;
   */
  experimentId?: string;

  /**
   * Concentration summary outputs, grouped by assay and sample
   *
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.ConcentrationSummaryRecord summary_analysis_results = 2;
   */
  summaryAnalysisResults: ConcentrationSummaryRecord[];

  /**
   * Detailed analysis outputs (per-replicate results)
   *
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.ReplicateResultRecord analysis_results = 3;
   */
  analysisResults: ReplicateResultRecord[];

  /**
   * Analysis results formatted for plot display
   *
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.CurveFitPlotData curve_fit_plot_data = 4;
   */
  curveFitPlotData: CurveFitPlotData[];
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ExperimentResults.
 * Use `create(ExperimentResultsSchema)` to create a new message.
 */
export const ExperimentResultsSchema: GenMessage<ExperimentResults> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_experiment_results, 0);

